<template>
    <page-wrapper>
        <page-header>
            <template v-slot:breadcrumbs>
                <q-breadcrumbs-el :label="$tc('common.reporting.finma-report.finma-report', 1)" :to="{ name: 'finma-report' }" />
            </template>

            <h1>{{ $tc('common.reporting.finma-report.finma-report', 1) }}</h1>
        </page-header>

        <div class="row">
            <div class="col-xs-12">
                <finma-report-form
                    ref="finmaReportForm"
                    @submit="handleSubmit"
                />
            </div>
        </div>
    </page-wrapper>
</template>

<script>
import FinmaReportForm from '@/components/reporting/finmaReport/FinmaReportForm.vue'
import { useI18n } from '@/composables/i18n'
import { useQuasar } from '@/composables/quasar'
import { ReportingService } from '@/services/reporting'
import { ref } from 'vue'

export default {
    name: 'FinmaReportCreate',
    meta () {
        return {
            title: this.$tc('common.reporting.finma-report.finma-report', 1),
        }
    },
    components: {
        FinmaReportForm,
    },
    setup () {
        const $q = useQuasar()
        const { tc } = useI18n()

        const finmaReportForm = ref(null)
        function handleSubmit (formData) {
            ReportingService.finmaReportsGenerate(formData)
                .then(response => {
                    finmaReportForm.value.formComponent.formBuilder.resetFormSubmitStatus()
                    finmaReportForm.value.resetSelectConsultingCompanies()

                    $q.notify({
                        type: 'positive',
                        message: tc('common.notifications.report.report-creation-started-success', formData.consultingCompanyIds.length),
                        caption: tc('common.notifications.report.report-email-notification-hint', formData.consultingCompanyIds.length),
                    })
                })
                .catch(error => {
                    finmaReportForm.value.formComponent.formBuilder.showFormErrorMessage(error)
                    finmaReportForm.value.formComponent.formBuilder.resetFormSubmitStatus()
                })
        }

        return {
            finmaReportForm,
            handleSubmit,
        }
    },
}
</script>
